// Old links to notification settings open the settings dialog on the notifications page.
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/preparer/notification-settings')({
  beforeLoad: () => {
    throw redirect({
      to: '/preparer/notifications',
      search: { settings: 'open' },
      replace: true,
    });
  },
  component: () => null,
});
